<template>
  <div name="assessmentReport">
    <section
      class="grid grid-flow-col gap-2 sm:auto-cols-min rounded w-full pt-2 mb-8"
      v-bind:class="isDashboardView === true ? 'grid-cols-1' : 'grid-cols-2'"
    >

      <div class="p-2 pb-4 bg-gray-100 rounded-lg" v-if="!isDashboardView">
        <h4 class="panel-header">
          Overall Assessment
        </h4>
        <barChart
          v-if="componentLoaded"
          :data-source="assessmentCount"
          :percentage="false"
          :key="'assessment'"
        ></barChart>
        <p v-else>We could not find any data for your given selection.</p>
      </div>

      <div class="p-2 bg-gray-100 rounded-lg">
        <h4 class="panel-header">
          Working at an expected level
        </h4>

        <horizontalBarChart
          v-if="
            workingAt.filter((x) => {
              return x.value > 0;
            }).length > 0
          "
          :data-source="workingAt"
          :percentage="true"
          :totalOveride="assessmentData.length"
        ></horizontalBarChart>
        <p v-else>We could not find any data for your given selection.</p>
      </div>
    </section>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { expectancies } from "@/assets/js/utils";

const horizontalBarChart = () =>
  import("@/components/charts/HorizontalBarChart.vue");
const barChart = () => import("@/components/charts/BarChart.vue");

export default {
  name: "assessmentReport",
  props: {
    isDashboardView: { type: Boolean, required: false },
    assessmentData: { type: Array, required: true },
  },
  computed: {
    ...mapGetters({
      settings: "settings"
    }),
    componentLoaded() {
      return this.assessmentData.length > 0;
    },
    gradesList() {
      return this.settings.assessmentGradesList.filter((c) => c.used === true );
    },
    assessmentCount() {
      let vm = this
      const scores = vm.assessmentData.map((a) => a.pupil) 

      let data = this.gradesList.map((grade) => {
        var filtered = scores.filter((aa) => {
          let value = vm.gradeFromScore(aa.grades.final_grade)
          if (value.length > 0) {
            return grade.score === value[0].score
          } 
        });

        return {
          name: grade.value,
          value: filtered.length,
          color: grade.chart_color,
        };
      });

      return data;
    },
    workingAt() {
      let vm = this
      const scores = vm.assessmentData.map((a) => a.pupil) 

      let data = expectancies.map((expectancy) => {
        var filtered = scores.filter((aa) => {
          let value = vm.gradeFromScore(aa.grades.final_grade)
          let score = value.length > 0 ? value[0].score : 0
            return  score >= expectancy.low && score < expectancy.high;
        });

          //console.log("FILTE LEB", expectancy.title, filtered.length);

        return {
          name: expectancy.title,
          value: filtered.length,
          color: expectancy.color,
        };
      });

      return data;
    },
  },
  data() {
    return {};
  },
  created() {},
  mounted() {},
  methods: {
    gradeFromScore(score) {
      const rounded = score != undefined ? score.toFixed(0) : 0
      let grade = this.gradesList.filter((g) => {
        return parseInt(rounded) === g.score
      })

      return grade
    },
  },
  components: {
    horizontalBarChart,
    barChart,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.titlebar {
  @apply text-sm font-semibold mb-6 w-full text-center;
}
</style>
